export default __webpack_public_path__ + "static/media/DD2.89ebd135.svg";